import axios from "axios";
import React, { Component,useEffect } from "react";
import { connect } from "react-redux";
import {set_datapage} from '../../redux/actions/DataPageAction';
import { baseUrl,localUrl } from "@ora/recursos/src/helpers/Url";
import "css/tablareporte.css";


function Cargando(props) {
  
    return (
      <p>Cargando...</p>
    );
}
function Tablareporte(props) {
    
    const headp = [];
    for (var key in props.data.colums) {
        headp.push(<th className="pvtColLabel"  colspan={props.data.colums[key].length} rowspan="1">{key}</th>);
    }
    const headh = [];
    for (const [key, value] of Object.entries(props.data.colums)) {
                
        headh.push(value.map((item) => { return(<th className="pvtColLabel"  colspan="1" rowspan="1">{item}</th>)}));
    }

    const rows = [];
    const total=[];
    
    for (var key in props.data.rows) {    
        var ncolum=0;
        const ritem=[];
        
        for (const [hkey, value] of Object.entries(props.data.colums)) {
            if (Object.entries(props.data.rows[key]).length>0) {
                for (var rkey of value) {
                    var temp=0
                    if (props.data.rows[key][hkey]!==undefined && Object.entries(props.data.rows[key][hkey]).length>0) {
                        temp=parseInt(props.data.rows[key][hkey][rkey])
                        ritem.push(<td className="pvtVal click" title="Revisar" onClick={props.clickitem} data-uicn={key} data-pais={hkey} data-recurso={rkey}>{props.data.rows[key][hkey][rkey]}</td>);                    
                    }else{                       
                        ritem.push(<td className="pvtVal">0</td>);
                    }
                    if (total[ncolum]==undefined) {
                        total[ncolum]=0
                    }
                    total[ncolum]+=temp
                    ncolum++
                }
            }else{
                for (var rkey of value) {
                    ritem.push(<td className="pvtVal">0</td>);
                }
               
            }
            
            
        }            
        rows.push( 
        <tr>
            <th className="pvtRowLabel">{key}</th>           
            {ritem}
        </tr>
        );
    }
    const trtotal=total.map((item,index) => {
        return(
            <td className="pvtTotal">{item}</td>
        )
    })
    

    return (
        <div className="table-container">
            <table className="pvtTable">
            <thead>
            <tr>
                <th className="pvtAxisLabel">Pais</th>               
                {headp}
                
            </tr>
            <tr>
                <th className="pvtAxisLabel">Lista CITES</th>
                {headh}
            </tr>
            </thead>
            <tbody>
                {rows}
                <tr>
                    <th className="pvtTotalLabel">Total</th>
                    {trtotal}
                </tr>
            </tbody>
            </table>
        </div>
    );
}
class Estadoconservacioncites extends Component {
    
    constructor (props) {
        super(props)
        this.props.set_datapage('Estados de Conservación en Lista de especies CITES')
        this.state = {
            lista:false,
            cites: false,
            iucn: false,     
            regpag:process.env.REG_PAG,
          };

        this.search={txt_ncc:"",sel_cites: "", sel_iucn: ""}     
       
    }
    componentDidMount() {
        axios.get(baseUrl(`cites/reportes/estadoconservacioncites`)).then(res => {
            this.initpage(res.data);
        })
    }
    initpage(result){
        var resultados = result;        
        console.info("%c--- get reporte ", "color:yellow;background:green");

        const itemCites= resultados.cites.map((item) => {
            return (
                <option value={item.var_txt_name}>{item.var_txt_description}</option>
            );
        })
        const itemIucn= resultados.iucn.map((item) => {
            return (
                <option value={item.var_txt_name}>{item.var_txt_description}</option>
            );
        })
        this.setState({
            iucn: itemIucn,
            cites: itemCites,
            lista: resultados.datos            
        })
       
       
        
    }
  
    

    buscar_simple = () => {
        var nc_nc=this.search['txt_ncc'];
        var cites=this.search['sel_cites'];
        var iucn=this.search['sel_iucn'];
        var url=baseUrl(`cites/reportes/estadoconservacion?l=25&o=0&tq=1&q1=`+nc_nc+'&q2='+cites+'&q3='+iucn)
        axios.get(url).then(res => {
            var datos=res.data.datos
            const confpivotTable={
                datos,
                rows: [
                "Estados de Conservación"
                ],
                cols: ["Pais","Libro"],
                aggregatorName: "Count",
                vals: ["Especie"]
            }             
        
            this.setState({
                lista: datos,
                pivotTable:confpivotTable
            })
        })
    }
    ir_detalle = (e) => {
        const { uicn,pais,recurso } = e.target.dataset;
        var url="/reportes/listaespecies?q3="+uicn+"&q4="+recurso+"&q5="+pais
        this.props.history.push(localUrl(url)) 
        
    }

    gestionarCambio = (event) => {
        if (event.target.type === "radio") {
            this.search[event.target.name]=event.target.value;
        } else {
            this.search[event.target.id]=event.target.value;
        }
      };


    render() {
        const TableComponent = this.state.lista?Tablareporte:Cargando;
        return (
            <div>
                <section className="section is-main-section">
                    <div className="card has-table">                  
                       
                        <div className="card-content">
                        <div className="b-table has-pagination">
                            <div className="table-wrapper has-mobile-cards">                               
                                <TableComponent data={this.state.lista} clickitem={this.ir_detalle}/>
                            </div>
                           
                            </div>
                        </div>
                    </div>
                </section>

            </div>
        )
    }
}

export default connect(null, {set_datapage})(Estadoconservacioncites)